var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("head-nav", { attrs: { menuItems: _vm.menuItems } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "seg-content general user" },
        [
          _vm.tab == "payment"
            ? [
                _c("div", { staticClass: "loading" }, [
                  _vm._v("(loading your payment)")
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.tab == "payment2"
            ? [
                _c("div", { staticStyle: { "grid-column": "span 8" } }, [
                  _c("iframe", {
                    staticClass: "payframe",
                    staticStyle: { height: "900px", width: "100%" },
                    attrs: { src: _vm.paymentReady }
                  })
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }